module.exports = __webpack_public_path__ + "static/media/td.a0923ddc.svg";